import { Component, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { MenuService } from '../../services/app.menu.service';
import { MenuItemComponent } from './menu-item/menuitem.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  standalone: true,
  imports: [MenuItemComponent],
})
export class MenuComponent implements OnInit {
  model: MenuItem[] = [];
  private menuService = inject(MenuService);
  ngOnInit() {
    this.model = this.menuService.getMenuItemsByRoles();
  }
}
